import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Lock, ArrowRight, Loader2, Eye, EyeOff } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_confusing-preview/artifacts/gu4q9ocf_trans_white_logo.png";
const DEMO_PASS = "agbor21222!";

const DemoGatePage = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    setTimeout(() => {
      if (password === DEMO_PASS) {
        localStorage.setItem('lekeewallet_demo_access', 'granted');
        navigate('/splash');
      } else {
        setError('Incorrect password. Please try again.');
      }
      setIsLoading(false);
    }, 600);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex flex-col items-center justify-center relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-primary/8 via-transparent to-transparent" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(224,32,32,0.06)_0%,transparent_70%)]" />

      <div className="relative z-10 w-full max-w-sm px-6 space-y-10">
        {/* Logo */}
        <div className="flex flex-col items-center">
          <div className="relative mb-6">
            <div className="absolute inset-0 bg-primary/20 blur-3xl rounded-full scale-150" />
            <img src={LOGO_URL} alt="LekeeWallet" className="h-16 w-auto relative z-10" />
          </div>
          <h1 className="text-2xl font-bold tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
            LekeeWallet Demo
          </h1>
          <p className="text-muted-foreground text-sm mt-2 text-center">
            Enter the access password to view the demo
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="relative">
            <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
            <Input
              type={showPassword ? 'text' : 'password'}
              placeholder="Enter demo password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setError(''); }}
              className="h-12 pl-11 pr-11 bg-white/5 border-white/10 focus:border-primary"
              data-testid="demo-gate-password"
              autoFocus
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-4 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
            >
              {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
            </button>
          </div>

          {error && (
            <p className="text-sm text-red-500 text-center" data-testid="demo-gate-error">{error}</p>
          )}

          <Button
            type="submit"
            className="w-full h-12 bg-primary hover:bg-red-600 text-white font-semibold glow-primary"
            disabled={isLoading || !password}
            data-testid="demo-gate-submit"
          >
            {isLoading ? (
              <Loader2 className="w-5 h-5 animate-spin" />
            ) : (
              <>
                View Demo
                <ArrowRight className="w-5 h-5 ml-2" />
              </>
            )}
          </Button>
        </form>
      </div>

      <div className="absolute bottom-8 text-center">
        <p className="text-xs text-muted-foreground">Part of the LekeeLekee ecosystem</p>
      </div>
    </div>
  );
};

export default DemoGatePage;
